import CoachAccreditationExplainerDialog from './coach-accreditation-explainer-dialog'

export { getAccreditationExplainer, getAccreditationBannerTeaser } from './explainers'
export default CoachAccreditationExplainerDialog
